import { useEffect, useState, ChangeEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./Task.css";
import Title from "../../Text/Title/Title";
import { SubTitle } from "../../Text/Subtitle/SubTitle";
import MultipleValueTextInput from "react-multivalue-text-input";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import UploadDbModal from "../../UploadDbModal/UploadDbModal";
import MoveTaskModal from '../../MoveTaskModal/MoveTaskModal.tsx'
import { VendaERPDefaultStatus } from "../../../Utils/staticData.js";
import ExternalFactorModal from '../../ExternalFactorModal/ExternalFactorModal.tsx'
import { Tooltip } from "react-tooltip";
import { objectIdToDate } from "../../../Utils/taskUtils.ts";

import {extrairNomeArquivo} from "../../../Functions/Functions.tsx";

import {
  Button,
  Col,
  Form,
  Input,
  Label,
  Row,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import {FaPen, FaTrash} from "react-icons/fa6";
import Select from "react-select";
import { IFrontTask, IPartnerCustomerRelationship, ITaskAction } from "../../../interfaces/ITask.tsx";

import { IMember } from "../../../interfaces/IMember.tsx";
import { useNotification } from "../../../hooks/useNotification";
import { FaPlusCircle, FaQuestionCircle } from "react-icons/fa";
import Badge from "../../Badge/Badge.tsx";
import ReactMarkdown from "react-markdown";
import { MdDeleteForever } from "react-icons/md";
import axios from "axios";
import { IStatus } from "../../../interfaces/IStatus.tsx";

function TaskEdit() {
  const { id } = useParams();
  const {
    getDashboardBadges,
    createTask,
    getTaskByTrelloId,
    updateTask,
    getMembers,
    getAllTools,
    moveTaskToList,
    getTaskActions,
    addNewComment,
    deleteComment,
    editComment,
    getAllStatus,
    updateTaskVersion,
    getCurrentMember
  } = useApiRequests();
  const { notify } = useNotification();
  const navigate = useNavigate();

  const [badges, setBadges] = useState(null);
  const [modal, setModal] = useState(false);
  const [modalEditComment, setModalEditComment] = useState(false);
  const [isVersionReadonly, setIsVersionReadonly] = useState(true);
  const [modalExternalFactor, setModalExternalFactor] = useState(false);

  const [emailsUploadDb, setEmailsUploadDb] = useState<IPartnerCustomerRelationship[]>([]);
  const [modalUploadDb, setModalUploadDb] = useState(false);


  const [actions, setActions] = useState<ITaskAction[]>([]);
  const [selectedTools, setSelectedTools] = useState<any[]>([]);
  const [tools, setTools] = useState<any[]>([]);
  const [selectedMembers, setSelectedMembers] = useState<any[]>([]);

  const [currentMember, setCurrentMember] = useState<IMember>();

  const [members, setMembers] = useState([]);
  const [emails, setEmails] = useState<string[]>([]);


  const [otherPartnerEmail, setOtherPartnerEmail] = useState<string>("");
  const [otherCustomerEmail, setOtherCustomerEmail] = useState<string>("");
  const [partnerCustomer, setPartnerCustomer] = useState<IPartnerCustomerRelationship[]>([])

  const [items, setItems] = useState<any[]>([]);
  const [newItem, setNewItem] = useState("");
  const [task, setTask] = useState<IFrontTask>({
    title: "",
    category: "",
    ticket: "",
    partnerEmail: "",
    customerEmail: "",
    partnersEmailsList: [],
    customersEmailsList: [],
    description: "",
    priority: "",
    testersIds: [],
    testersNames: [],
    complexity: "",
    finishDate: "0001-01-01T00:00:00.000Z",
    version: "",
    labelIds: [],
    partnersCustomers: [],
    emailsToNotify: [],
    resources: [],
    membersName: [],
    memberIds: [],
    toolsIds: [],
    versions: [],
    toolsName: [],
    parentTaskId: '',
    evidencies: [],
    listId: "",
    listName: "",
    testerId: "",
    testerName: "",
    screenerId: "",
    screenerName: "",
    flow: "",
    fromApi: false,
    isAproved: false,
    isCustomization: false,
    creatorName: '',
    devName: [],
    prManager: {},
    trelloId: '',
    allResourcesEvidencies: []
  });

  const [newComment, setNewComment] = useState("");
  const [commentToEdit, setCommentToEdit] = useState<string>("");
  const [auxText, setAuxText] = useState("");

  const [files, setFiles] = useState<FileList | null>(null);

  const [statusList, setStatusList] = useState<IStatus[]>([]);

 
  const [modalDeleteEvidency, setModalDeleteEvidency] = useState(false)
  const [evidencyToDelete, setEvidencyToDelete] = useState<string>('')

  const [modalMoveTask, setModalMoveTask] = useState(false);
  const [statusNameToMoveManually, setStatusNameToMoveManually] = useState('');
  const [modalRemoveFlow, setModalRemoveFlow] = useState(false)


  const getTask = async () => {
    try {
      const taskData = await getTaskByTrelloId(id || "");
      if (taskData.success) {
        if (
          taskData.data.listId == "62b08e977c338d65d8ff1882" ||
          taskData.data.listId == "62b08e9f0ed8ca2b69246f78"
        ) {
          setIsVersionReadonly(false);
        }

        setTask(taskData.data);
        setItems(taskData.data.evidencies);
        const members = taskData.data.membersName.map(
          (memberName: string, index: number) => ({
            value: taskData.data.memberIds[index],
            label: memberName,
          })
        );

        const tools = taskData.data.toolsName.map((toolName: string, index:number) => ({
          value: taskData.data.toolsIds[index],
          label: toolName,
        }));

        setSelectedTools(tools);
        setSelectedMembers(members);
        setEmails(taskData.data.emailsToNotify);


      } else {
        notify(taskData.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  useEffect(()=> {
    if(statusNameToMoveManually !== ''){
      setModalMoveTask(!modalMoveTask)
    }
  },[statusNameToMoveManually])
  
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files;
    setFiles(selectedFiles || null);
  };

  const handleUpload = async (id: string) => {
    if (files) {
      try {
        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
          formData.append(`file${i}`, files[i]);
        }

        const response = await axios.post(
          `https://devtracker.vendaerp.com.br/Tasks/upload-task-resources/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          }
        );

        if (response.status === 200) {
          setTimeout(() => {
            window.location.href = `/task/edit/${id}`;
          }, 800);
        } else {
          notify("A tarefa foi criada, porém o upload falhou!", {
            type: "alert",
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {

    if(id && id != "new"){
      const novaUrl = window.location.pathname.replace("edit","view")
      history.replaceState(null,"",novaUrl)
    }

    if (
      task != null &&
      task.membersName != null &&
      task.membersName.length > 0
    ) {
      setSelectedMembers(
        task.membersName.map((memberName: string, index: number) => ({
          value: task.memberIds[index],
          label: memberName,
        }))
      );
    }
    if (task != null && task.toolsName != null && task.toolsName.length > 0) {
      
       setSelectedTools(
        task.toolsName.map((tools, index) => ({
          value: task.toolsIds[index],
          label: tools,
        }))
      );
    }
    if(task!=null && task.partnersCustomers != null && task.partnersCustomers.length > 0){
      setPartnerCustomer(task.partnersCustomers);
    }
  }, [task]);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const data = await getMembers();
        if (data.success) 
          setMembers(data.data);
        
      } catch (error) {
        notify(error, { type: "error" });
      }
    };

    const fetchTools = async () => {
      try {
        const data = await getAllTools();
          if (data.success) {
              const transformedData = data.data.map((tool: any) => ({
                  value: tool.id,
                  label: tool.name,
              }));
              setTools(transformedData);
          }
        
      } catch (error) {
        notify(error, { type: "error" });
      }
    };

    const getStatus = async () => {
      const data = await getAllStatus();
      if (data.data) {
        setStatusList(data.data);
      }
    };

    getStatus();
    fetchMembers();
    fetchTools();
    fetchCurrentMember();
    if (id !== "new") {
      getTask();
      fetchActions();
    }
  }, []);


  const fetchCurrentMember = async () => {
    try {
      let data = await getCurrentMember()
      if(data.success){
        setCurrentMember(data.data)
      }
    }catch(e) {

    }
  }

  const toggleUploadDbModal = () => {
    setModalUploadDb(!modalUploadDb);
  };

  const canUserMoveTask = ()=> {
    return (currentMember?.memberType === "2" ||
    currentMember?.type === 2 ||
    currentMember?.canMoveTasksManually);
  }

  const addPartnerCustomer = () => {
    if( otherPartnerEmail === '' &&  otherCustomerEmail === ''){
      notify("Você precisa preencher os dois campos", { type: "error" });
      return;
    }

    if( (otherPartnerEmail === '' &&  otherCustomerEmail !== '') || (otherPartnerEmail !== '' &&  otherCustomerEmail === '') ){
      notify("Você precisa preencher os dois campos", { type: "error" });
      return;
    }

    let partCustList = partnerCustomer;
    let newPartCust: IPartnerCustomerRelationship = {partnerEmail: otherPartnerEmail, customerEmail: otherCustomerEmail}
    partCustList?.push(newPartCust)
    setPartnerCustomer(partCustList)
    setOtherPartnerEmail('');
    setOtherCustomerEmail('');
  }

  const removePartnerCustomer = (partCustomer: IPartnerCustomerRelationship) => {
    let newPartCust: IPartnerCustomerRelationship[] = partnerCustomer.filter(pc => !(pc.partnerEmail === partCustomer.partnerEmail && pc.customerEmail === partCustomer.customerEmail));
    setPartnerCustomer(newPartCust)
  }

  const fetchActions = async () => {
    try {
      const data = await getTaskActions(id || "");
      if (data.success) {
        if (data.data != null) {
          setActions(data.data);
        }
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleAddItem = () => {
    if (newItem.trim() !== "") {
      setItems([...items, { id: "", link: newItem, taskTrelloId: "" }]);
      setNewItem("");
    }
  };

  const handleFieldChange = (
    fieldName: keyof IFrontTask,
    value: string | string[]
  ) => {
    setTask({ ...task, [fieldName]: value });
  };


  const handleSaveTaskVersion = async (version: string) => {
    if(id === 'new' || id === ''){
      return;
    }

    try {
      var data = await updateTaskVersion(version, id || '')

      if(data.success){
        notify("Versão salva com sucesso!", {type: "success"});
        setTask(data.data)
      }
    } catch (err) {
      notify(err, {type: "error"});
    }
  } 

  const handleSaveTask = async () => {
    const btn = document.getElementById("save-btn") as any;
    btn.disabled = true;
    btn.innerHTML = "...";
    try {
      setTask({
        ...task,
        emailsToNotify: emails,
        partnersCustomers: partnerCustomer,
        memberIds: selectedMembers.map(e => e.value) as string[],
        membersName: selectedMembers.map(e => e.label) as string[],
        evidencies: items,
        toolsIds: selectedTools.map(e => e.value) as string[],
        toolsName: selectedTools.map(e => e.label) as string[],
      });

      //O react não atualiza o state nessa mesma chamada, então vou atualizar o valor de Task e mandar um objeto clone
      const currentTask = {
        ...task,
        emailsToNotify: emails,
        partnersCustomers: partnerCustomer,
        memberIds: selectedMembers.map(e => e.value) as string[],
        membersName: selectedMembers.map(e => e.label) as string[],                  
        toolsIds: selectedTools.map(e => e.value) as string[],
        toolsName: selectedTools.map(e => e.label) as string[],
        evidencies: items,
      };

      const response =
        id != "new"
          ? await updateTask(currentTask as IFrontTask)
          : await createTask(currentTask as IFrontTask);
      if (response.success) {
        notify(
          id != "new"
            ? "Tarefa atualizada com sucesso!"
            : "Tarefa criada com sucesso!",
          "success"
        );

        if (files != null) 
          handleUpload(response.data.trelloId);
         if(id != "new")
          setTask(response.data)
         else 
          setTimeout(()=> window.location.href = `/task/view/${response.data.trelloId}`,700)
        
      } else {
        try {
          // Tenta fazer parse como JSON (para erros de validação tradicional)
          var parsedMSG = JSON.parse(response.msg || "");
          if(parsedMSG && Array.isArray(parsedMSG)) {
            parsedMSG.forEach( (e:string) => notify(e, { type: "error" }))
          }
        } catch (jsonError) {
          // Se não conseguir fazer parse como JSON, trata como string simples (validação por IA)
          if(response.msg) {
            notify(response.msg, { type: "error" });
          }
        }
      }
    } 
    catch (error) {
      notify(error, { type: "error" });
    } 
    finally {
      btn.disabled = false;
      btn.innerHTML = id !== "new" ? "Atualizar" : "Salvar";
    }
  };

  const handleGoBack = () => {
    const lastHref = localStorage.getItem("lastHref");

    if(lastHref)
      window.location.href = lastHref;
  };

  const handleWithMemberSelect = (values: any) => {
    setSelectedMembers(values);
  };

  const handleWithToolsSelect = (values: any) => {
    setSelectedTools(values);
  };

  const handleMoveTask = async (name: string) => {
    try {
      const data = await moveTaskToList(name, id || "");
      if (data.success) {
        notify("Movido com sucesso", { type: "success" });
        setTimeout(() => {
          getTask()
        }, 200);
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleNewComment = async () => {
    const btn = document.getElementById("btn-comment-new") as any;

    btn.disabled = true;
    btn.innerHTML = "...";

    try {
      if (newComment == "" || newComment.length == 0) {
        notify("O comentário não pode ser vazio!", { type: "info" });
      } else {
        const data = await addNewComment(id || '', newComment, '');

        fetchActions();
        setModal(false);
        setNewComment("");
      }
    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      btn.disabled = false;
      btn.innerHTML = "Confirmar";
    }
  };

  const handleDeleteComment = async (commentId: string) => {
    const btn = document.getElementById("btn-delete-comment") as any;

    btn.disabled = true;

    try {
      const data = await deleteComment(id || "", commentId);
      if(data.success){
        setActions(data.data);
        setNewComment("");
        notify("Sucesso!", { type: "success" });
      }

    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      btn.disabled = false;      
    }
  };

  const handleEditComment = async () => {
    const btn = document.getElementById("btn-edit-comment") as any;

    btn.disabled = true;
    btn.innerHTML = "...";

    try {
      if (newComment == "" || newComment.length == 0) {
        notify("O comentário não pode ser vazio!", { type: "info" });
      } else {
        const data = await editComment(id || "", commentToEdit, newComment);
        fetchActions();
        setModalEditComment(false);
        setNewComment("");
        notify("Sucesso!", { type: "success" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    } finally {
      btn.disabled = false;
      btn.innerHTML = "Confirmar";
    }
  };

  const handleRemoveResource = async (itemLink: string) => {
    var resources = JSON.parse(JSON.stringify(items));
    const filtered = resources.filter((old: any) => old.link !== itemLink);
    setItems(filtered);
  };

  const handleEnterKey = (e: any) => {
    if (e.key === "Enter") {
      if (task.flow === null || task.flow.length == 0) {
        setTask({ ...task, flow: auxText });
      } else {
        setTask({ ...task, flow: `${task.flow} -> ${auxText}` });
      }
      setAuxText("");
    }
  };

  const handleClickResource = (link: string) => {
    window.open(link, "_blank");
  };

  const handleUploadHomologacao = () => {
    // Copia a lista de outros parceiros e outros clientes
    var copy = JSON.parse(JSON.stringify(task));
    let partnerCustomerUpload: IPartnerCustomerRelationship[] = copy.partnersCustomers
    let pc:IPartnerCustomerRelationship = {partnerEmail: copy.partnerEmail, customerEmail: copy.customerEmail}
    partnerCustomerUpload.push(pc)
    setEmailsUploadDb(partnerCustomerUpload)
    toggleUploadDbModal()
  }

  return (
    <div className="page-container task-view-container">
      <Tooltip id="breadcrumb-tooltip" />
      <Tooltip id="outros-parceiros-tooltip"></Tooltip>
      <Tooltip id="publicacao-versao-tooltip" style={{zIndex:999}}></Tooltip>

      <div className="task-header">
        <Row>
          <Col md={8}>
            <div className="task-title-section">
              {/* Status Badge */}
              <div className="task-status-badge-container">
                {statusList.map((item, index) => {
                  if (item.id == task.listId) {
                    return (
                      <div key={index} className={`status-badge status-${item.name.toLowerCase().replace(/\s+/g, '-')}`}>
                        📍 {item.name}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
              
              <h2>{task.title || "Nova Tarefa"}</h2>
              
              {/* Breadcrumb */}
              <div className="task-breadcrumb">
                {statusList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`task-breadcrumb-item ${item.id == task.listId ? 'active' : ''}`}
                    >
                      <span>{item.name}</span>
                      {statusList.length - 1 !== index && <span>›</span>}
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>
          <Col md={4} className="task-actions-section">
            <div className="d-flex gap-2">
              <Button
                color="secondary"
                className="task-action-dropdown"
                onClick={() => handleGoBack()}
              >
                Voltar
              </Button>
              {id !== "new" && (
                <UncontrolledDropdown>
                  <DropdownToggle caret color="primary" className="task-action-dropdown">
                    Mais Ações
                  </DropdownToggle>
                  <DropdownMenu className="custom-dropdown-menu">
                    <DropdownItem
                    className="custom-dropdown-item"
                      onClick={() => (window.location.href = `/task/view/${id}`)}
                    >
                      Visualizar
                    </DropdownItem>

                    {
                    task.listId == VendaERPDefaultStatus.FatorExterno &&
                    <DropdownItem
                      className="custom-dropdown-item"
                      onClick={() => setModalExternalFactor(!modalExternalFactor)}
                    >
                      Criar Tarefa de Análise
                    </DropdownItem>
                    }
                    <DropdownItem 
                    className="custom-dropdown-item"
                    onClick={() => handleUploadHomologacao()}>
                        Clonar base(s)
                    </DropdownItem>
                  {// memberType "2" é o gerenciador
                  canUserMoveTask() &&              
                    <span>
                      <DropdownItem 
                      className="custom-dropdown-item"
                      header>
                        <b style={{ color: "#2528ff" }}>Mover Tarefa Para:</b>
                      </DropdownItem>            
                      {             
                       statusList != null &&
                        statusList.map((e, i) => {
                          return (
                            <DropdownItem
                            className="custom-dropdown-item"
                              key={i}
                              onClick={() => setStatusNameToMoveManually(e.name)}
                            >
                              {e.name}
                            </DropdownItem>
                          );
                        })
                      }
                    </span>}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              <Button
                color="success"
                className="task-primary-button"
                id="save-btn"
                onClick={handleSaveTask}
              >
                {id !== "new" ? "Atualizar" : "Salvar"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      <div className="task-responsible-section">
        <div className="task-responsible-content">
          <span className="task-responsible-label">Responsáveis:</span>
          <div className="task-responsible-names">
            {selectedMembers != null &&
              selectedMembers.map((member, index) => {
                return (
                  <span className="task-responsible-name" key={index}>
                    {member.label}
                  </span>
                );
              })}
          </div>
          {selectedTools != null && selectedTools.length > 0 && (
            <>
              <span>|</span>
              <span className="task-responsible-label">Software:</span>
              <div className="task-responsible-names">
                {selectedTools.map((tool, index) => {
                  return (
                    <span className="task-responsible-name" key={index}>
                      {tool.label}
                    </span>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>

      <div className="task-divider"></div>

      <div className="mt-5 mb-5">
        <Form>
          <div className="task-edit-content">
            {/* Informações Básicas */}
            <div className="task-info-card">
              <h3>📋 Informações Básicas</h3>
              <Row>
                <Col md={12}>
                  <Label for="task-title" className="label theme-text-color">
                    Título
                  </Label>
                  <Input
                    className="custom-input"
                    type="text"
                    required
                    placeholder="Título da tarefa"
                    value={task.title}
                    onChange={(e) => handleFieldChange("title", e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={12}>
                  <Label for="task-members" className="label theme-text-color">
                    Membros
                  </Label>
                  {members != null && members.length > 0 && (
                    <Select
                      isMulti
                      name="task-members"
                      options={members}
                      onChange={(value) => handleWithMemberSelect(value)}
                      value={selectedMembers != null ? selectedMembers : []}
                      className="basic-multi-select custom-input"
                      classNamePrefix="select"
                      placeholder="Selecione"
                    />
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={6}>
                  <Label for="task-tools" className="label theme-text-color">
                    Ferramentas do Sistema
                  </Label>
                  {tools != null && tools.length > 0 && (
                    <Select
                      isMulti
                      name="task-tools"
                      options={tools}
                      onChange={(value) => handleWithToolsSelect(value)}
                      value={selectedTools != null ? selectedTools : []}
                      className="basic-multi-select custom-input"
                      classNamePrefix="select"
                      placeholder="Selecione"
                    />
                  )}
                </Col>
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <Label className="theme-text-color label" for="task-version">
                      Versão da publicação
                    </Label>
                    <FaQuestionCircle
                      style={{ marginLeft: "0.5rem", cursor: "pointer" }}
                      color="grey"
                      data-tooltip-id="publicacao-versao-tooltip"
                      data-tooltip-place="top"
                      data-tooltip-html="Quando houver mais de uma ferramenta na tarefa, insira as versões <br/> na mesma ordem em que foram informadas as Ferramentas e separadas por ';' <br/> Ex: 1.2.3;4.5.0 <br/><br/>Casa você queira atualizar apenas a versão de uma das ferramentas, <br/>preencha esse campo no seguinte formato: 000;1.2.3 <br/> A string '000' representa a versão da ferramenta/software que não está sendo atualizada."
                    />
                  </div>
                  <Input
                    className="custom-input"
                    id="task-version"
                    type="text"
                    onBlur={(e)=> handleSaveTaskVersion(e.target.value)}
                    placeholder="Versão da Publicação"
                    value={task.version}
                    onChange={(e) => handleFieldChange("version", e.target.value)}
                  />  
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={6}>
                  <Label className="theme-text-color" for="task-priority">Prioridade</Label>
                  <Input
                   className="custom-input"
                    id="task-priority"
                    name="task-priority"
                    type="select"
                    value={task.priority}
                    onChange={(e) => handleFieldChange("priority", e.target.value)}
                  >
                    <option value="-1">Selecione</option>
                    <option value="veryHigh">Altíssima</option>
                    <option value="high">Alta</option>
                    <option value="medium">Média</option>
                    <option value="low">Baixa</option>
                    <option value="veryLow">Muito Baixa</option>
                  </Input>
                </Col>
                <Col md={6}>
                  <Label className="theme-text-color" for="task-priority">Status</Label>
                  <Input
                  className="custom-input"
                    id="task-status"
                    name="task-status"
                    type="text"
                    value={task.listName}
                    disabled
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={6}>
                  <Label for="task-ticket" className="label theme-text-color">
                    Ticket
                  </Label>
                  <Input
                  className="custom-input"
                    type="text"
                    required
                    placeholder="Nº Ticket"
                    value={task.ticket}
                    onChange={(e) => handleFieldChange("ticket", e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <Label for="task-category" className="label theme-text-color">
                    Categoria
                  </Label>
                  <Input
                  className="custom-input"
                    type="select"
                    required
                    value={task.category}
                    onChange={(e) => handleFieldChange("category", e.target.value)}
                  >
                    <option value="-1">Selecione</option>
                    <option value="bug">Correção</option>
                    <option value="customization">Customização</option>
                    <option value="feat">Nova Implementação</option>
                  </Input>
                </Col>
              </Row>
            </div>

            {/* Informações do Parceiro */}
            <div className="task-info-card">
              <h3>🏢 Informações do Parceiro</h3>
              <Row>
                <Col md={6}>
                  <Label className="label theme-text-color">
                    Email do Parceiro
                  </Label>
                  <Input
                  className="custom-input"
                    type="text"
                    required
                    placeholder="Email do parceiro com problema."
                    value={task.partnerEmail}
                    onChange={(e) =>
                      handleFieldChange("partnerEmail", e.target.value)
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label className="label theme-text-color">
                    Email do Cliente do Parceiro
                  </Label>
                  <Input
                  className="custom-input"
                    type="text"
                    required
                    placeholder="Email do cliente com problema."
                    value={task.customerEmail}
                    onChange={(e) =>
                      handleFieldChange("customerEmail", e.target.value)
                    }
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={12}>
                  <Label className="theme-text-color">
                    Outros parceiros e clientes com o mesmo problema
                    <FaQuestionCircle
                      style={{ marginLeft: "0.5rem", marginBottom: "1px" }}
                      color="grey"
                      data-tooltip-id="outros-parceiros-tooltip"
                      data-tooltip-place="right"
                      data-tooltip-html="Esses parceiros também serão notificados por email. <br/> Se você adicionar um email nesse campo, você terá que preencher o email do cliente no campo ao lado"
                    />
                  </Label>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={5}>
                  <Label className="theme-text-color">Email do Parceiro</Label>
                  <Input
                    className="custom-input"
                    onChange={(e) => setOtherPartnerEmail(e.target.value)}
                    value={otherPartnerEmail}
                    type="text"
                    name="item-input"
                    placeholder="Adicione o email do parceiro"
                  />
                </Col>
                <Col md={5}>
                  <Label className="theme-text-color">Email do Cliente</Label>
                  <Input
                    className="custom-input"
                    onChange={(e) => setOtherCustomerEmail(e.target.value)}
                    type="text"
                    name="item-input"
                    placeholder="Adicione o email do cliente"
                    value={otherCustomerEmail}
                  />
                </Col>
                <Col md={2} className="d-flex align-items-end">
                  <Button 
                    color="primary" 
                    onClick={() => {
                      addPartnerCustomer()
                    }}
                    style={{ width: "100%", height: "38px" }}
                  >
                    <FaPlusCircle color="#fff" />
                  </Button>
                </Col>
              </Row>
                
              <Row >
                  <Col className="mt-2" md={12}>
                    {
                    partnerCustomer != null && partnerCustomer.length > 0 &&
                    partnerCustomer.map((pc, index) => (
                      <p key={index} style={{color:"gray"}}> <strong>Parceiro:</strong> {pc.partnerEmail}&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;<strong>Cliente:</strong> {pc.customerEmail}                
                        <button
                        onClick={() => removePartnerCustomer(pc)}
                        className="btn btn-danger"
                        style={{ marginLeft: "1rem", cursor: "pointer" }}>                   
                            <FaTrash color="white"/>
                      </button>
                     </p>              
                    ))
                    }
                  </Col>
              </Row>

               <Row className="mt-3">
                <Col md={12}>
                  <Label className="theme-text-color">Emails secundários para notificação</Label>
                  <MultipleValueTextInput
                    onItemAdded={(item, allItems) => setEmails([...allItems])}
                    onItemDeleted={(item, allItems) => setEmails([...allItems])}
                    values={emails != null ? emails : []}
                    name="item-input"
                    className="multi-value custom-input"
                    placeholder="Adicione o email e aperte enter"
                  />
                </Col>
              </Row>
            </div>

            {/* Resumo do Problema */}
            <div className="task-info-card">
              <h3>📝 Resumo do Problema</h3>
              <Row className="mt-3">
                <Col md={12}>
                  <Label for="task-title" className="label theme-text-color">
                    Fluxo dentro do sistema
                  </Label>
                  <div className="flow-help-text mb-2" style={{ 
                    fontSize: '0.875rem', 
                    padding: '0.75rem',
                    borderRadius: '0.375rem',
                    marginBottom: '0.5rem'
                  }}>
                    <strong>📝 Como preencher:</strong> Descreva o passo a passo para reproduzir o problema.<br/>
                    <strong>✏️ Exemplo:</strong> Menu Principal → Vendas → Cadastrar Cliente → Salvar<br/>
                    <strong>⚡ Instruções:</strong> Digite uma etapa por vez e pressione <kbd>ENTER</kbd> após cada etapa.
                  </div>
                  <Input
                  className="custom-input"
                    type="text"
                    required
                    onKeyDown={(e) => handleEnterKey(e)}
                    maxLength={150}
                    placeholder="Ex: Menu Principal → Vendas → Cadastrar Cliente"
                    value={auxText}
                    onChange={(e) => setAuxText(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                {task.flow != null && task.flow.length > 0 && (
                  <Col md={12} className="theme-text-color">
                    <strong>Fluxo atual:</strong> {task.flow}{" "}
                    <span
                      onClick={() => setModalRemoveFlow(!modalRemoveFlow)}
                      className="btn btn-danger"
                      style={{ marginLeft: "1rem", cursor: "pointer" }}>                   
                          <FaTrash color="white" />
                    </span>
                  </Col>
                )}
              </Row>
              <Row className="mt-3">
                <Col md={12}>
                  <Label for="task-title" className="label theme-text-color">
                    Descrição do Erro
                  </Label>
                  <Input
                    className="custom-input"
                    type="textarea"
                    required
                    placeholder="Descreva o erro e demais informações úteis para solução do problema."
                    rows="8"
                    value={task.description}
                    onChange={(e) => handleFieldChange("description", e.target.value)}
                  />
                </Col>
              </Row>
              {/* Campo de descrição privada */}
              {currentMember && currentMember.type !== undefined && currentMember.type !== 'Viewer' && (
                <Row className="mt-3">
                  <Col md={12}>
                    <Label for="private-description" className="label theme-text-color">
                      Descrição Privada (visível apenas para equipe interna)
                    </Label>
                    <Input
                      className="custom-input private-description-box"
                      type="textarea"
                      required={false}
                      placeholder="Informações sensíveis, notas internas, etc."
                      rows="4"
                      value={task.privateDescription || ""}
                      onChange={(e) => handleFieldChange("privateDescription", e.target.value)}
                    />
                  </Col>
                </Row>
              )}
            </div>

            {/* Evidências */}
            <div className="evidence-section">
              <div className="evidence-header">
                <h3 className="evidence-title">📎 Evidências</h3>
              </div>
              <Row className="mt-3">
                <Col md={12}>
                  <Label className="theme-text-color">Faça upload de Evidências</Label>
                  <Input
                  className="custom-input"
                    type="file"
                    name="file"
                    id="evidencies-files"
                    multiple
                    onChange={handleFileChange}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={12}>
                  <Label className="theme-text-color">Ou envie o link das Evidências</Label>
                  <div className="d-flex gap-2">
                    <Input
                    className="custom-input"
                      type="text"
                      value={newItem}
                      onChange={(e) => setNewItem(e.target.value)}
                      placeholder="Links que mostrem o problema ocorrendo."
                    />
                    <Button color="primary" onClick={handleAddItem}>
                      <FaPlusCircle color="#fff" />
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={12}>
                  <ul>
                    {items.map((item, index) => (
                      <li
                        style={{
                          marginLeft: "1rem",
                          maxWidth: "90%",
                          cursor: "pointer",
                          display:"flex",
                          alignItems:"center",
                        }}
                        key={index}
                      >
                        <p className="theme-text-color mt-3" onClick={() => handleClickResource(item.link)}>
                          {extrairNomeArquivo(item.link).slice(0, 30)}                      
                        </p>
                        <Button                
                          onClick={() => {
                            let link = item.link?.toString() || ""
                            setEvidencyToDelete(link)
                            setModalDeleteEvidency(!modalDeleteEvidency)
                          }}
                          className="btn btn-danger"
                          style={{ marginLeft: "1rem", cursor: "pointer" }}>                   
                              <FaTrash color="white"/>
                        </Button>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </div>
          </div>
        </Form>
      </div>

      {/* Histórico de Comentários */}
      <div className="history-section">
        <div className="history-header">
          <h3 className="history-title">🕒 Histórico de Atividades</h3>
          <Button
            className="history-new-comment-btn"
            onClick={() => setModal(true)}
          >
            💬 Novo Comentário
          </Button>
        </div>
        <div className="history-timeline">
          {actions != null &&
            actions.map((comment: ITaskAction, index) => {
              return (
                <div key={index} className="timeline-item">
                  <div className="timeline-marker" style={{ backgroundColor: "#3b82f6" }}>
                    <span className="timeline-icon">💬</span>
                  </div>
                  <div className="timeline-content">
                    <div className="timeline-header">
                      <div className="timeline-meta">
                        <span className="timeline-date">
                          {comment.id ? objectIdToDate(comment.id) : "Data não disponível"}
                        </span>
                        <span className="timeline-separator">•</span>
                        <span className="timeline-creator">
                          {comment.creator != null ? comment.creator : "Não Identificado"}
                        </span>
                      </div>
                      {comment.canEdit && comment.id && (
                        <div className="timeline-actions">
                          <button
                            className="timeline-action-btn edit-btn"
                            onClick={() => {
                              setNewComment(comment.description);
                              setCommentToEdit(comment.id!);
                              setModalEditComment(true);
                            }}
                            title="Editar comentário"
                          >
                            <FaPen />
                          </button>
                          <button
                            className="timeline-action-btn delete-btn"
                            onClick={() => {
                              handleDeleteComment(comment.id!);
                            }}
                            title="Excluir comentário"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="timeline-body">
                      <ReactMarkdown className="markdown timeline-markdown">
                        {comment.descriptionWithLinks ? comment.descriptionWithLinks : comment.description}
                      </ReactMarkdown>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {/* Modais existentes */}
      <Modal 
      className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`} 
      isOpen={modal} toggle={() => setModal(false)}>
        <ModalHeader className="modal-header-style theme-text-color">Novo Comentário</ModalHeader>
        <ModalBody className="modal-body-style">
          <Input
          className="input-modal theme-text-color"
            id="exampleText"
            name="text"
            type="textarea"
            rows="8"
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
          />
        </ModalBody>
        <ModalFooter className="modal-footer-style">
          <Button
            color="primary"
            onClick={() => handleNewComment()}
            id="btn-comment-new"
          >
            Confirmar
          </Button>{" "}
          <Button color="secondary" onClick={() => setModal(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`} 
        isOpen={modalEditComment}
        toggle={() => setModalEditComment(false)}
      >
        <ModalHeader className="modal-header-style">Editar Comentário</ModalHeader>
        <ModalBody className="modal-body-style">
          <Input
          className="input-modal theme-text-color"
            id="exampleText"
            name="text"
            type="textarea"
            rows="8"
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
          />
        </ModalBody>
        <ModalFooter className="modal-footer-style">
          <Button
            color="primary"
            onClick={() => handleEditComment()}
            id="btn-edit-comment"
          >
            Confirmar
          </Button>{" "}
          <Button color="secondary" onClick={() => setModalEditComment(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>


    <MoveTaskModal
    isOpen={modalMoveTask}
    toggleModal={()=> setModalMoveTask(!modalMoveTask)}
    moveTask={()=> handleMoveTask(statusNameToMoveManually)}
    >
    </MoveTaskModal>


      <Modal
      className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`} 
      isOpen={modalDeleteEvidency} toggle={() => setModalDeleteEvidency(!modalDeleteEvidency)}>
        <ModalHeader className="modal-header-style theme-text-color">Excluir evidência</ModalHeader>
        <ModalBody className="modal-body-style">
          <b style={{ color: "red" }}>
            Você tem certeza que deseja excluir essa evidência?
          </b>
        </ModalBody>
        <ModalFooter className="modal-footer-style">
          <Button
            color="primary"
            onClick={() => {
              handleRemoveResource(evidencyToDelete)

              setTimeout(()=> {
                setModalDeleteEvidency(!modalDeleteEvidency)
              },200)
            }}
          >
            Confirmar
          </Button>{" "}
          <Button color="secondary" onClick={() => setModalDeleteEvidency(!modalDeleteEvidency)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>



      <UploadDbModal
        taskId={id ? id : ''}
        isOpen={modalUploadDb}
        toggleUploadDbModal={toggleUploadDbModal}
        partnerCustomer={emailsUploadDb}
      ></UploadDbModal>


      <Modal 
      className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`} 
      isOpen={modalRemoveFlow} toggle={() => setModalRemoveFlow(!modalRemoveFlow)}>
        <ModalHeader className="modal-header-style theme-text-color">Excluir fluxo</ModalHeader>
        <ModalBody className="modal-body-style">
          <b style={{ color: "red" }}>
            Você tem certeza que deseja excluir esse fluxo?
          </b>
        </ModalBody>
        <ModalFooter className="modal-footer-style">
          <Button
            color="primary"
            onClick={() => {
              handleFieldChange("flow", "")
              setTimeout(()=> {
                setModalRemoveFlow(!modalRemoveFlow)
              },200)
            }}
          >
            Confirmar
          </Button>{" "}
          <Button color="secondary" onClick={() => setModalRemoveFlow(!modalRemoveFlow)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      <ExternalFactorModal
        isOpen={modalExternalFactor}
        toggleModal={()=> {setModalExternalFactor(!modalExternalFactor)}}
        taskId={id ? id : ""}
        />


    </div>
  );
}

export default TaskEdit;
